import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { useAppDataContext } from './context/AppDataContext';
import { useTranslation } from './i18n/index.jsx';
import LoginScreen from './components/auth/LoginScreen';
import AdminApp from './components/admin/AdminApp';
import StaffApp from './components/staff/StaffApp';

function App() {
  const { user, isLoading, handleLogin, handleLogout } = useAuth();
  const { users, setUsers } = useAppDataContext();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-t-bg flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-4 animate-pulse">🍷</div>
          <div className="text-t-secondary">{t('app.loading')}</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginScreen onLogin={handleLogin} users={users} setUsers={setUsers} />;
  }

  // Role-based routing: staff gets StaffApp routes, admin gets AdminApp routes
  if (user.role === 'staff') {
    return (
      <Routes>
        <Route path="/*" element={<StaffApp />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/*" element={<AdminApp />} />
    </Routes>
  );
}

export default App;
